import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { MoreVertical, Trash2 } from 'lucide-react';

import { Button } from '@/components/Button/Button';

import styles from './ChatOverflowMenu.module.css';

interface ChatOverflowMenuProps {
  onClearConversation: () => void;
}

// Destructive and rare actions live behind a kebab rather than sitting in the
// header. Clearing a conversation is unrecoverable, so it should take a
// deliberate second step to reach — and the item says what it does rather than
// relying on a trash icon to imply it.
export function ChatOverflowMenu({ onClearConversation }: ChatOverflowMenuProps) {
  return (
    <DropdownMenu.Root modal={false}>
      <DropdownMenu.Trigger asChild>
        <Button
          aria-label="Conversation options"
          className={styles.trigger}
          iconOnly
          variant="ghost"
        >
          <MoreVertical aria-hidden="true" size={18} />
        </Button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end"
          className={styles.content}
          sideOffset={6}
        >
          <DropdownMenu.Item
            className={styles.destructiveItem}
            onSelect={onClearConversation}
          >
            <Trash2 aria-hidden="true" size={16} />
            <span className={styles.itemText}>
              <span className={styles.itemLabel}>Clear conversation</span>
              <span className={styles.itemDescription}>
                Deletes this chapter&rsquo;s conversation for good
              </span>
            </span>
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
